import { render } from "./HeaderMs.vue?vue&type=template&id=edfc73d2"
import script from "./HeaderMs.vue?vue&type=script&lang=js"
export * from "./HeaderMs.vue?vue&type=script&lang=js"

import "./HeaderMs.vue?vue&type=style&index=0&id=edfc73d2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__